const SuccessStatusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none">
    <path
      fill="#17AB71"
      d="M33.16 15.38a2 2 0 0 1 .46 2.78l-10 14a2 2 0 0 1-1.46.84H22a2.001 2.001 0 0 1-1.42-.58l-6-6a2.008 2.008 0 1 1 2.84-2.84l4.32 4.34 8.64-12a2 2 0 0 1 2.78-.54ZM44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0Zm-4 0a16 16 0 1 0-32 0 16 16 0 0 0 32 0Z"
    />
  </svg>
);

export default SuccessStatusIcon;
